export enum UserSettingKeysEnum {
    Language = "Organizer.Language",
    DateTimeFormat = "Organizer.DateTimeFormat",
    DefaultLocationIds = "Organizer.DefaultLocationIds",
    DefaultFavoriteId = "Organizer.DefaultFavoriteId",
    DefaultCategoryIds = "Organizer.DefaultCategoryIds",
}
export enum SystemSettingKeysEnum {
    IsEnableLocationCheckbox = "ResourceFinder.EnableLocationCheckbox",
    FavouriteListNoOfMostUsedResources = "FavouriteList.NoOfMostUsedResources",
    ResourceFinderPageSize = "ResourceFinder.PageSize",
    AttendeePageSize = "ResourceFinder.Attendee.PageSize",
    AddinTrimLocation = "Addin.TrimLocation",
    DateFormat = "@DateFormat",
    DateSeperator = "@DateSeperator",
    TimeFormat = "@TimeFormat",
    ResourceFinderAssistantOrganizer = "ResourceFinder.AssistantOrganizer",
    ResourceFinderOrderFormVisible = "ResourceFinder.OrderForm.Visible",
    EnableSOF = "EnableSOF",
    ResourceFinderDetailVisible = "ResourceFinder.Detail.Visible",
    ResourceFinderDisplayDetailCapacity = "ResourceFinder.DisplayDetailCapacity",
    ResourceFinderDisplayDetailDeadLineInform = "ResourceFinder.DisplayDetailDeadLineInform",
    ResourceFinderDisplayDetailDescription = "ResourceFinder.DisplayDetailDescription",
    ResourceFinderDisplayDetailEmail = "ResourceFinder.DisplayDetailEmail",
    ResourceFinderDisplayDetailFurtherDetail = "ResourceFinder.DisplayDetailFurtherDetail",
    ResourceFinderDisplayDetailLightResource = "ResourceFinder.DisplayDetailLightResource",
    ResourceFinderDisplayDetailLocation = "ResourceFinder.DisplayDetailLocation",
    ResourceFinderDisplayDetailName = "ResourceFinder.DisplayDetailName",
    WebAddinDisabledPlatforms = "@WebAddInDisabledPlatforms",
    ResourceFinderTo = "ResourceFinder.To",
    ResourceFinderFrom = "ResourceFinder.From",
    ExchangeConflictRulesEnable = "ExchangeConflictRules.Enable",
    ResourceFinderDisplayHightLightBufferTime = "ResourceFinder.DisplayHighLightBufferTime",
    OutlookAddinTimeLineVisible = "OutlookAddin.TimeLine.Visible",
    ResourceFinderDisablePermission = "ResourceFinder.DisablePermission",
    ResourceFinderFloorPlan = "ResourceFinder.FloorPlan",
    EnableCloseLocation = "RC.ClosedPeriod",
    //ResourceFinderRecurringAlternativeLimit ="ResourceFinder.Recurring.AlternativeLimit",
    ResourceFinderRecurringEnableAlternative = "ResourceFinder.Recurring.EnableAlternative",
    DefaultFirstDayOfWeek = "RC.WeekStartDay",
}
export enum WebAddinPlatforms {
    Outlook2016 = 1,
    OutlookForMac = 2,
    OWA = 3,
    DesktopClient = 4,
    undefined = 5,
}
export const allAppSettingKeys: string[] = Object.values(SystemSettingKeysEnum);